import { forwardRef } from 'react';
import * as StyledSwitch from './styled/switch';

export interface SwitchProps extends StyledSwitch.RootProps {
  labelPosition?: 'before' | 'after';
}

export const Switch = forwardRef<HTMLLabelElement, SwitchProps>(
  (props, ref) => {
    const { children, labelPosition = 'after', ...rootProps } = props;

    return (
      <StyledSwitch.Root ref={ref} {...rootProps}>
        {children && labelPosition === 'before' && (
          <StyledSwitch.Label>{children}</StyledSwitch.Label>
        )}
        <StyledSwitch.Control>
          <StyledSwitch.Thumb />
        </StyledSwitch.Control>
        {children && labelPosition === 'after' && (
          <StyledSwitch.Label>{children}</StyledSwitch.Label>
        )}
        <StyledSwitch.HiddenInput />
      </StyledSwitch.Root>
    );
  },
);

Switch.displayName = 'Switch';
